import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import ErrorMessage from "../../../../components/ErrorMessage";

const LatestNewsCard = ({ schema, news, onUpdate, onDelete }) => {
  const { id, titleEn, newsLink } = news;
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: { titleEn, newsLink },
  });

  const onSubmit = (data) => {
    const { titleEn, newsLink } = data;
    onUpdate(
      {
        ...news,
        titleEn,
        newsLink,
      },
      id
    );
  };

  useEffect(() => {
    setValue("titleEn", titleEn);
    setValue("newsLink", newsLink);
  }, []);

  return (
    <div className="latest-news-sign-record pt-5">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form__div-container">
          <div className="form__div">
            <input className="form__input" {...register("titleEn")} />
            <label htmlFor="" className="form__label">
              News Title
            </label>
          </div>
          {errors.titleEn && <ErrorMessage message={errors.titleEn?.message} />}
        </div>
        <div className="form__div-container">
          <div className="form__div">
            <input className="form__input" {...register("newsLink")} />
            <label htmlFor="" className="form__label">
              News Link
            </label>
          </div>
          {errors.newsLink && (
            <ErrorMessage message={errors.newsLink?.message} />
          )}
        </div>
        <div className="mt-3 d-flex justify-content-end">
          <button
            type="button"
            className="delete-btn"
            onClick={() => onDelete(id)}
          >
            Delete
          </button>
          <button type="submit" className="save-btn ml-2">
            Update
          </button>
        </div>
      </form>
    </div>
  );
};

export default LatestNewsCard;
